import { Box, Caption, LinkText, TextCell } from "@bcc-ui/ui-components";
import { t } from "i18next";
import React from "react";
import { CellProps, Column } from "react-table";

import { GradeBadge, isGrade } from "./grade-badge/GradeBadge";
import { GradingActionSelect } from "components/asset-management-system/custom-views/tabs/value/steps/value-recovery-step/grading-action-select/GradingActionSelect";
import { AssetPathKey } from "domain/asset-management/assetPathMapping";
import { Asset } from "services/asset-management/AssetService";

export const createColumns = () => {
    const columns: Array<Column<Asset>> = [];

    columns.push({
        Header: () => t("AssetManagement.assetId"),
        accessor: "assetId",
        Cell: ({ row: { original: asset } }: CellProps<Asset>) => (
            //TODO Should open TableSidePanel
            <TextCell>
                <Box>
                    <LinkText as={"button"} onClick={() => {}}>
                        {asset.assetId}
                    </LinkText>
                </Box>
            </TextCell>
        ),
        width: 220,
        minWidth: 120,
    });

    columns.push({
        Header: () => t("AssetManagement.value.gradingTable.typeHeader"),
        accessor: "assetType",
        Cell: ({ row: { original: asset } }: CellProps<Asset>) => (
            <TextCell>
                <Box columnLayout gap="Xxs">
                    {asset.assetType}
                    {asset.model !== undefined && <Caption greyTextStyle>{asset.model}</Caption>}
                </Box>
            </TextCell>
        ),
        width: 240,
        minWidth: 120,
    });

    columns.push({
        Header: () => t("AssetManagement.value.gradingTable.gradeHeader"),
        accessor: AssetPathKey.BLANCCO_GRADE as keyof Asset,
        Cell: ({ cell: { value } }: CellProps<Asset>) => {
            if (!isGrade(value)) {
                return null;
            }
            return <GradeBadge grade={value} bold />;
        },
        width: 200,
        minWidth: 100,
    });

    columns.push({
        Header: () => t("AssetManagement.value.gradingTable.actionHeader"),
        accessor: "action",
        disableSortBy: true,
        Cell: ({ row: { original: asset } }: CellProps<Asset>) => (
            <GradingActionSelect key={asset.uuid} asset={asset} />
        ),
        width: 300,
        minWidth: 200,
    });
    return columns;
};
